<form [formGroup]="bankAccountFormGroup">
    <div class="form-field row">
        <p class="form-field-heading col-sm-12">Your Name as in Bank Account</p>
        <mat-form-field class="col-sm-12">
            <input matInput type="text" formControlName="accountHolderName" placeholder="Account Holder's Name">
            <mat-error>{{ getErrorMessage(bankAccountFormGroup.controls.accountHolderName) }}</mat-error>
        </mat-form-field>
    </div>

    <div class="form-field row">
        <p class="form-field-heading col-sm-12">Account Type</p>
        <mat-form-field class="col-sm-12">
            <mat-select placeholder="Select Account Type" name="accountType"
                        formControlName="accountType" required>
                <mat-option *ngFor="let accountType of accountTypes" [value]="accountType.value">
                    {{ accountType.viewValue }}
                </mat-option>
            </mat-select>
            <mat-error>{{ getErrorMessage(bankAccountFormGroup.controls.accountType) }}</mat-error>
        </mat-form-field>
    </div>

    <div formGroupName="accountNumberGroup">
        <div class="form-field row">
            <p class="form-field-heading col-sm-12">Account Number</p>
            <mat-form-field class="col-sm-12">
                <input matInput type="password" formControlName="accountNumber"
                       placeholder="Eg : 1234567890" oncopy="return false" oncut="return false"
                       onpaste="return false" digitOnly>
                <mat-error>{{ getErrorMessage(bankAccountFormGroup.get('accountNumberGroup').get('accountNumber'))}}</mat-error>
            </mat-form-field>
        </div>

        <div class="form-field row">
            <p class="form-field-heading col-sm-12">Confirm Account Number</p>
            <mat-form-field class="col-sm-12">
                <input matInput type="text" formControlName="repeatedAccountNumber"
                       placeholder="Eg : 1234567890" oncopy="return false" oncut="return false"
                       onpaste="return false" appOnlyNumber>
            </mat-form-field>
        </div>

        <small *ngIf="!isAccountNumberEmpty()">
            <mat-error class="small">
                {{ getErrorMessage(bankAccountFormGroup.get('accountNumberGroup').get('repeatedAccountNumber')) || getErrorMessage(bankAccountFormGroup.get('accountNumberGroup')) }}
            </mat-error>
        </small>
    </div>
</form>